import React, { useEffect, useState } from 'react';
import { css, keyframes } from '@emotion/core';
import { useT } from 'client/i18n/hooks/useT';

const TRANSITION_SPEED = '300ms';

const alertTextCss = css`
  color: #fff;
  font-size: 1.4rem;
  line-height: 1.8rem;
  text-align: center;
  transition: color ${TRANSITION_SPEED};
`;

export function ConnectionAlert() {
  const t = useT();
  const [showSecondaryAlert, setShowSecondaryAlert] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowSecondaryAlert(true);
    }, 20000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  function getContent() {
    return showSecondaryAlert ? (
      <>
        <p css={alertTextCss}>
          {t(
            'CallJoin.ConnectionAlert.TroubleConnectingMessage',
            'Trouble connecting?',
            'Call with friends feature, connecting issue message'
          )}
        </p>
        <p css={alertTextCss}>
          {t(
            'CallJoin.ConnectionAlert.TryRejoiningMessage',
            'Try leaving and rejoining the recording.',
            'Call with friends feature, connecting issue message'
          )}
        </p>
      </>
    ) : (
      <div>
        <p
          css={alertTextCss}
          dangerouslySetInnerHTML={{
            __html: t(
              'CallJoin.ConnectionAlert.RecordingTip',
              'For the best recording, everyone should be <strong>connected</strong>.',
              'Call with friends feature, recording tip'
            ),
          }}
        />
      </div>
    );
  }
  return (
    <div css={getAlertContainerCss(showSecondaryAlert)}>{getContent()}</div>
  );
}

const enterAnimation = keyframes`
  0% {
    opacity: 0;
    transform: translate3d(0px, 10px, 0px);
  }

  100% {
    opacity: 1;
    transform: translate3d(0px, 0px, 0px);
  }
`;

function getAlertContainerCss(showSecondaryAlert: boolean) {
  return css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 300px;
    height: 72px;
    margin: auto;
    margin-bottom: 20px;
    padding: 20px;
    border-radius: 8px;
    background-color: ${showSecondaryAlert ? '#5000b9' : '#7F8287'};
    transition: background-color ${TRANSITION_SPEED};
    animation: ${enterAnimation} ${TRANSITION_SPEED};
  `;
}
